import { useEffect } from 'react';

import { useContentLabelFilterStore } from '../../../store/content-label-filter';
import type { LabelCategory } from '../../settings/labels/types';

type ReconcileArgs = { categories: LabelCategory[]; loading: boolean; error?: Error };

/**
 * Drops selected label ids the categories no longer have: deleted in Settings, emptied in this
 * portfolio, or all of them once the flag resolves off. A loading or failed read is no evidence of
 * a deletion, so it waits for a settled, successful one.
 */
export function useReconcileContentLabelsFilter({ categories, loading, error }: ReconcileArgs): void {
  useEffect(() => {
    if (loading || error) return;
    useContentLabelFilterStore.getState().pruneContentLabels(categories);
  }, [categories, loading, error]);
}
